import classNames from 'classnames';
import { Icon } from '../../atoms/icon';
import { Link, PrismicImageWithAlt } from '@/components';
import { ImageField } from '@prismicio/client';
import { CSSProperties } from 'react';

interface SocialNetworkData {
  url: string;
  icon?: ImageField | null;
}

interface NetworksStructure {
  [key: string]: SocialNetworkData;
}

interface SocialsProps {
  networks: NetworksStructure;
  className?: string;
  iconWidth?: number;
  [key: string]: any;
}

const isValidIcon = (icon?: ImageField | null): boolean => {
  if (!icon || typeof icon !== 'object') return false;

  return Boolean(icon?.url && icon.url?.length > 0);
};

function Socials({ networks, className, iconWidth, ...props }: SocialsProps) {
  return (
    <div className={classNames('socials', className)} {...props}>
      {Object.keys(networks ?? {})?.map(net => {
        const socialData = networks[net];

        if (!socialData?.url) {
          return null;
        }

        const hasCustomIcon = isValidIcon(socialData.icon);

        return (
          <Link
            aria-label={`Go to ${net} in a new tab`}
            className="socials__item"
            href={socialData.url}
            key={net}
            rel="noopener noreferrer"
            target="_blank"
            title={net}
          >
            {hasCustomIcon ? (
              <PrismicImageWithAlt
                defaultAlt={`${net} icon`}
                field={socialData.icon}
                style={
                  {
                    objectFit: 'contain',
                    width: `${iconWidth || 14}px`,
                  } as CSSProperties
                }
              />
            ) : (
              <Icon name={net} />
            )}
          </Link>
        );
      })}
    </div>
  );
}

export { Socials };
export type { SocialsProps, NetworksStructure, SocialNetworkData };
